export const dataListBlockSx = {
    '& .printout-block-shell[data-printout-block-type="printoutDataList"]': {
        marginTop: "8mm",
        marginBottom: "8mm",
    },
};
